const messages = Object.freeze({
  DANGER: 'danger',
  SUCCESS: 'success',
  WARNING: 'warning',
  INFO: 'info'
})

export default messages